/* import __COLOCATED_TEMPLATE__ from './configuration-selector.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import type StandardizedPlatform from 'embercom/objects/standalone/platforms/standardized-platform';

interface Signature {
  Args: {
    platform: StandardizedPlatform<any>;
    formatLabel: (config: any) => string;
  };
}

export default class ConfigurationSelector extends Component<Signature> {
  get platform() {
    return this.args.platform;
  }

  get configurations() {
    return this.platform.configurations ?? [];
  }

  get activeConfiguration() {
    return this.platform.activeConfiguration;
  }

  get showSelector() {
    return this.configurations.length > 1;
  }

  get configurationOptions() {
    return this.configurations.map((config) => ({
      value: config.id,
      text: this.args.formatLabel(config),
    }));
  }

  @action
  selectConfiguration(configId: string) {
    let config = this.configurations.find((c) => c.id === configId);
    if (config) {
      this.platform.switchToConfiguration(config);
    }
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Standalone::ConfigurationSelector': typeof ConfigurationSelector;
    'standalone/configuration-selector': typeof ConfigurationSelector;
  }
}
